var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('talmundo-switch',{attrs:{"id":"showGdprText","label":_vm.$t('labels.showGdprText')},on:{"change":function($event){return _vm.changeVisibility($event, 'showGdprText')}},model:{value:(_vm.showGdprText),callback:function ($$v) {_vm.showGdprText=$$v},expression:"showGdprText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }